import React from 'react';
import './InfoBar.css';
export enum InfoMessageType {
  success = 'success',
  error = 'danger',
  warning = 'warning',
  none = 'light'
}

export interface IInfobarContent {
  Message: string;
  MessageType: InfoMessageType;
  linkText?: string;
  onClickLink?: () => void;
}
export interface IInfoDetails extends IInfobarContent{
  closeClick: (val: boolean) => void;
}
const InfoBar: React.FC<IInfoDetails> = ({
  Message,
  MessageType,
  closeClick = () => {},
  linkText,
  onClickLink
}) => {
  return (
    <>
      {
        <div className={`alert alert-${MessageType} info-bar-${MessageType}`} data-testid="infoBarTest">
          <span className={`close-${MessageType}`} onClick={() => closeClick(false)}>
            <i
              className="bi bi-x"
              style={{ right:'40px', position: 'absolute' }}
              data-testid="infoBarClose"
            ></i>
          </span>
          <span>{Message}</span>
          &nbsp;
          <span onClick={onClickLink} style={{textDecoration: 'underline', cursor: 'pointer'}}>{linkText}</span>
        </div>
      }
    </>
  );
};
export default InfoBar;
